/**
 * Execute an API request with standardized error handling
 * @param {Function} apiCall - The API call function to execute
 * @param {string} defaultErrorMessage - Default error message if no error message can be extracted
 * @returns {Promise} - Promise that resolves with the API call result
 */
export const executeApiRequest = async (apiCall, defaultErrorMessage = 'Operation failed') => {
  try {
    return await apiCall();
  } catch (error) {
    // Extract error message from different error formats
    let errorMessage = defaultErrorMessage;

    if (error.data && error.data.message) {
      // Handle H3 error format from the server
      errorMessage = error.data.message;
    } else if (error.message) {
      // Handle standard error format
      errorMessage = error.message;
    } else if (typeof error === 'string') {
      // Handle string error
      errorMessage = error;
    }

    // Create a standardized error object
    const errorObject = {
      success: false,
      message: errorMessage,
    };

    throw errorObject;
  }
};
